import { BUTTON_VARIANTS } from 'ui/button';

export type ToolbarTheme = {
  bgColor: string;
  borderColor: string;
  btnVariant: BUTTON_VARIANTS;
  shadow: string;
};

export enum Modals {
  CreativeLibrary = 'creativeLibrary',
  DynamicContentBuilder = 'dynamicContentBuilder',
  MovableInk = 'movableInk',
  None = 'none',
  SnippetSelector = 'snippetSelector',
}
